import * as updateCookiePopupSettings from '@/api/crm/cookiePopup/updatePopupSettings';
import * as getCookiePopupSettings from '@/api/crm/cookiePopup/getPopupSettings';


export default {
    namespaced: true,
    state: {
        cookiePopupSettings: null,
    },
    mutations: {
        gotCookiePopupSettings(state, result) {
            state.cookiePopupSettings = result;
        },
    },
    actions: {
        async update({ dispatch }, dto) {
            await updateCookiePopupSettings.put(dto);
        },
        async get({ commit }, id) {
            const result = await getCookiePopupSettings.get();
            if (result) commit("gotCookiePopupSettings", result);
        },
    },
    getters: {
        cookiePopupSettings: state => state.cookiePopupSettings,
    }
};
